<template>
  <div class="form-box">
    <FormTitle :infoName="infoName" />
    <div class="form-list">
      <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="demo-ruleForm" @submit.native.prevent>
        <el-form-item label="请输入实习报告标题">
          <el-input v-model="ruleForm.title"
                    type="text"
                    placeholder="请输入实习报告标题"
                    maxlength="50"
                    show-word-limit></el-input>
        </el-form-item>
        <div class="box-g2">
          <el-form-item class="lis-g2" label="请输入实习岗位">
            <el-input v-model="ruleForm.extParam.internshipPosition"
                      type="text"
                      placeholder="输入实习岗位，如：新媒体运营"
                      maxlength="20"></el-input>
          </el-form-item>
          <el-form-item class="lis-g2" label="请输入实习单位">
            <el-input v-model="ruleForm.extParam.internshipUnit"
                      type="text"
                      placeholder="请输入实习企业 (单位)，如：xxxx科技有限公司"
                      maxlength="20"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="请输入实习内容">
          <el-input type="textarea"
            v-model="ruleForm.extParam.internshipContent"
            :rows="4"
            placeholder="请输入实习内容。如：负责编制公司会计凭证，审核、装订及保管各类会计凭证等"
            maxlength="500"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="模型选择">
          <el-radio-group v-model="ruleForm.extParam.modelCode">
              <el-radio :label="1">标准版</el-radio>
              <el-radio :label="2">
                专业版
                <el-tooltip class="item" effect="light" content="篇幅更长,研究领域更广,内容更精准" placement="top-start">
                  <i class="el-icon-info" style="color: #ffaa00;"></i>
                </el-tooltip>
              </el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="选择字数">
          <el-radio-group v-model="ruleForm.extParam.creationWordsNum" class="radio-pc-show">
            <el-radio-button v-for="(item,index) in internshipInfo.num" :label="item">{{item + '字左右'}}</el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="ruleForm.extParam.creationWordsNum" class="radio-h5-show h5-el-radio">
            <el-radio v-for="item in internshipInfo.num" :label="item">{{item + '字左右'}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn">
      <el-checkbox class="form-check" v-model="btnInfo.checked">{{btnInfo.title}}</el-checkbox>
      <el-button style="width: 180px" type="primary" :disabled="!btnInfo.checked" @click="submitForm('ruleForm')">立即创作</el-button>
    </div>

    <NoticeWrapper />
  </div>
</template>

<script>
  import InternshipApi from '@/api/internship'
  import CommonApi from "@/api/common"
  import { orderMixin } from '@/utils/orderMixin'
  import { validateTitle } from '@/utils/validate'
  import FormTitle from "@/components/FormTitle/index.vue"
  import NoticeWrapper from "@/components/NoticeWrapper/index.vue"
	export default {
    components: {NoticeWrapper, FormTitle},
    mixins: [orderMixin],
    props: ['infoName'],
		data() {
			return {
        ruleForm: {
          title: '',
          creationDocId: 13,
          creationDocCode: 'INTERNSHIP_REPORT',
          channelCode: null,
          extParam: {
            version: 1,
            education: -1,
            modelCode: 1,
            internshipContent: '',
            internshipPosition: '',
            internshipUnit: '',
            creationWordsNum: null
          }
        },
        // rules: {
        //   title: [
        //     { required: true, message: '请输入实习报告标题', trigger: 'blur' },
        //     { validator: validateTitle, trigger: 'blur' }
        //   ],
        //   extParam: {
        //     internshipContent: [
        //       { required: true, message: '请输入实习内容', trigger: 'blur' }
        //     ],
        //     internshipPosition: [
        //       { required: true, message: '请输入实习岗位', trigger: 'blur' }
        //     ],
        //     internshipUnit: [
        //       { required: true, message: '请输入实习单位', trigger: 'blur' }
        //     ],
        //     creationWordsNum: [
        //       { required: true, message: '请选择字数', trigger: 'change' },
        //     ]
        //   }
        // },
        btnInfo: {
          title: '我已阅读并同意: 所有的范文仅用于格式和思路参考',
          checked: true
        },
        internshipInfo: {
          num: ''
        },
        paramsData: '', // 储存跳页面的传值
			}
		},
		created() {
      this.getWordsNum()
    },
		methods: {
      //获取字数
      getWordsNum(){
        InternshipApi.getWordsNum().then(res => {
          this.internshipInfo.num = res.data;
          this.ruleForm.extParam.creationWordsNum = this.internshipInfo.num[0]
        }).catch(() => {
        })
      },
      submitForm(formName) {
        let _this = this
        if(_this.ruleForm.title === ''){
          return _this.$message({
            message: '请输入实习报告标题',
            type: 'warning',
            duration: 2000,
            customClass: "focus-message",
          });
        }else if(_this.ruleForm.title.length < 5){
          return _this.$message({
            message: '标题长度需要至少5个字!',
            type: 'warning',
            duration: 2000,
            customClass: "focus-message",
          });
        }
        if(_this.ruleForm.extParam.internshipPosition === ''){
          return _this.$message({
            message: '请输入实习岗位',
            type: 'warning',
            duration: 2000,
            customClass: "focus-message",
          });
        }
        if(_this.ruleForm.extParam.internshipUnit === ''){
          return _this.$message({
            message: '请输入实习单位',
            type: 'warning',
            duration: 2000,
            customClass: "focus-message",
          });
        }
        if(_this.ruleForm.extParam.internshipContent === ''){
          return _this.$message({
            message: '请输入实习内容',
            type: 'warning',
            duration: 2000,
            customClass: "focus-message",
          });
        }

        _this.paramsData = _this.ruleForm
        let info = JSON.stringify(_this.ruleForm.extParam)
        _this.ruleForm.extParam = info
        //生成订单 mixin
        _this.createOrder(_this.ruleForm,_this.paramsData)

        // this.$refs[formName].validate((valid) => {
        //   if (valid) {
        //     _this.paramsData = _this.ruleForm
        //     let info = JSON.stringify(_this.ruleForm.extParam)
        //     _this.ruleForm.extParam = info
        //     //生成订单 mixin
        //     _this.createOrder(_this.ruleForm,_this.paramsData)
        //   } else {
        //     return false;
        //   }
        // });
      },
      // resetForm(formName) {
      //   this.$refs[formName].resetFields();
      // }
		}
	}
</script>

<style lang="less" scoped>
@import "@/assets/css/pageContent";
.box-g2{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .lis-g2{
    width: 48%;
  }
}
@media screen and (max-width: 900px) {
  .box-g2{
    flex-direction: column;
    .lis-g2{
      width: 100%;
    }
  }
}
</style>
